import { InvoiceV2Output } from '@allocab/allocab-invoice-service-types';

import { PrimaryButton } from '../../components/button/PrimaryButton';
import { useDownloadInvoiceV2 } from '../../hooks/useDownloadInvoiceV2';
import { t } from '../../services/translation/translation';

type Props = {
  invoice: InvoiceV2Output;
};

export const InvoiceV2DownloadButton = ({ invoice }: Props) => {
  const { mutate: downloadInvoice, isLoading } = useDownloadInvoiceV2();

  return (
    <PrimaryButton
      text={t('common.download')}
      className="mr-0 ml-auto"
      onClick={() => downloadInvoice(invoice)}
      isLoading={isLoading}
    />
  );
};
